module.exports = __webpack_public_path__ + "static/media/bg-success.095c4c82.jpg";